import { render, staticRenderFns } from "./anDetail.vue?vue&type=template&id=1042ce72&scoped=true"
import script from "./anDetail.vue?vue&type=script&lang=js"
export * from "./anDetail.vue?vue&type=script&lang=js"
import style0 from "./anDetail.vue?vue&type=style&index=0&id=1042ce72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1042ce72",
  null
  
)

export default component.exports